import CalculatorReportOfferCTA from "@/components/CalculatorReportOfferCTA";

/**
 * Intent-matched paid-report offer for chart-derived calculator pages whose
 * result is read straight off the birth chart — dasamsa (D10), rashi
 * calculator (Moon sign), etc. All point at the same grahas the full
 * `brihat_kundali` reads, so the matched upgrade is the `birth_chart`-intent
 * primary (rule 40). Placed BELOW the calculator result so the page still leads
 * with its tool (rules 43/45) and carries exactly one offer (rule 39).
 *
 * The bridge/direct-checkout decision and telemetry live in the generic
 * CalculatorReportOfferCTA. This wrapper only locks the governed Brihat plan,
 * so dedicated and Brihat calculator offers cannot drift into two money paths.
 */
export default function CalculatorBrihatReportCTA({
  language = "en",
  sourcePath,
  placement,
  customerProblem,
  headline,
  subhead,
  name,
  birthDate,
  birthTime,
  birthPlace,
}: {
  language?: "en" | "hi";
  /** The page the offer is shown on (for accurate attribution). */
  sourcePath: string;
  /** Stable placement tag for the impression + click events. */
  placement: string;
  /** Short customer-problem tag (e.g. "dasamsa", "rashi"). */
  customerProblem: string;
  headline: string;
  subhead: string;
  /** Birth details the seeker ALREADY entered on this calculator — carried into
   * the /free-kundali form's hash so they don't re-type them (the #1 leak is
   * offer→cart friction, not checkout). Each is optional; a missing field
   * leaves the form blank exactly as before. The hash stays client-side, so no
   * DOB reaches a server log. Read by KundaliFormCard.prefill's
   * readDirectPrefillFromUrl. */
  name?: string;
  birthDate?: string;
  birthTime?: string;
  birthPlace?: string;
}) {
  return (
    <CalculatorReportOfferCTA
      planId="brihat_kundali"
      language={language}
      sourcePath={sourcePath}
      placement={placement}
      customerProblem={customerProblem}
      headline={headline}
      subhead={subhead}
      name={name}
      birthDate={birthDate}
      birthTime={birthTime}
      birthPlace={birthPlace}
    />
  );
}
